var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-list',{attrs:{"finished":_vm.finished,"finished-text":_vm.finishedText},on:{"load":_vm.loadList},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_vm._t("default",null,{"list":_vm.list})],2)}
var staticRenderFns = []

export { render, staticRenderFns }